import { FunctionComponent } from "react";

import DevDeviceQr from "src/components/dev/DevDeviceQr";
import { useIsDev, useIsTouchLikeDevice } from "src/hooks";

import { DEV_OVERLAY_MESSAGING_SLOT_ID } from "./dev-overlay-stack-ids";
import * as styles from "./DevOverlayStack.css";

/**
 * Fixed bottom-right flex stack for dev overlays. Messaging panels portal into the
 * slot above the device QR control so expanded panels do not overlap.
 */
const DevOverlayStack: FunctionComponent = () => {
  const isDev = useIsDev();
  const isTouchLike = useIsTouchLikeDevice();

  if (!isDev || isTouchLike) {
    return null;
  }

  return (
    <div className={styles.stack}>
      <div
        id={DEV_OVERLAY_MESSAGING_SLOT_ID}
        className={styles.messagingSlot}
      />
      <DevDeviceQr />
    </div>
  );
};

export default DevOverlayStack;
